import NavbarBottomAdmin from './components/navbarBottomAdmin'
import NavbarTopAdmin from './components/navbarTopAdmin'
import AuthProvider from '../Authentication/authProvider'
import axios from 'axios'
import { useEffect, useState, useRef } from 'react'

function Converter() {
    const [video, setVideo] = useState({ video: null, nomeVideo: null })
    const [msg, setMsg] = useState(null)

    const videoChange = (e) => {
        const v = document.getElementById('progress')
        v.style.width = '0'; document.getElementById('container').style.border = '1px solid transparent'
        const r = e.target.files[0]
        setVideo({ video: r, nomeVideo: r.name }); setMsg(null)
    }
    const handleSubmit = async (e) => {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        const v = document.getElementById('progress')
        v.style.width = '90%'; v.style.transition = 'width 20s'; document.getElementById('container').style.border = '1px solid black'
        try {
            const fd = new FormData()
            fd.append('video', video.video); fd.append('nomeVideo', video.nomeVideo); fd.append('stato', 'noAwsBucket')
            const res = await axios.post('/convertVideo/compress_on', fd, {
                headers: { "Content-Type": "multipart/form-data" }
            }); console.log(res.data)
            if (res.data === 'success') {
                setMsg("Video salvato in cartella server/controllers/uploads")
                v.style.transition = 'width 0.1s'; v.style.width = '100%'
            }
        } catch (err) { console.log(err) }
    }

    // useEffect(() => { console.log(video.video) }, [video.video])

    return (<>
        <NavbarTopAdmin />
        <NavbarBottomAdmin />
        <AuthProvider />
        <div className='container'><br /><br />
            <h2 className='text-center mt-5' style={{ color: 'navy' }}>Video compression</h2>
            <br /><hr />
            <div className='mt-2'>
                <form onSubmit={handleSubmit}>
                    <input
                        type='file'
                        name='video'
                        accept="video/*"
                        onChange={videoChange}
                    />
                    <div className='mt-3'>
                        {video.video &&
                            <div>
                                <video src={URL.createObjectURL(video.video)} width={300} height={180} controls />
                                <p>{video.nomeVideo}</p>
                            </div>
                        }
                    </div>
                    {/* ------------ barra di avanzamento ----------------------- */}
                    <div style={{ width: '35%', backgroundColor: 'transparent' }} id='container'>
                        <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise', transition: 'width 20s' }} id='progress'>
                        </div>
                    </div>
                    <hr />

                    <p style={{ color: 'red' }}>{msg}</p>
                    <button type='submit' style={{ float: 'right' }} className='btn btn-primary'>Avanti</button>
                </form>
            </div>
        </div>
    </>)
}
export default Converter